import { useDisposable } from 'mobx-react-lite'

import { whenGoingOnline } from '../helpers/offline'

export function useOnConnectionRestored(callback: () => void) {
  useDisposable(() => whenGoingOnline(callback))
}
